import { defineStore } from 'pinia';

import type { LineSelectableFields } from '@onrunning/backstage-models';
import { useLocalStorage, type RemovableRef } from '@vueuse/core';

export interface State {
  selectableFields: RemovableRef<LineSelectableFields>;
}

export const useOrderDownloadStore = defineStore('orderDownload', {
  state: (): State => ({
    selectableFields: useLocalStorage<LineSelectableFields>('selectedFields', {}),
  }),
  actions: {
    setSelectableFields(fields: LineSelectableFields) {
      Object.assign(this.selectableFields, fields);
    },
    $reset() {
      Object.assign(this.selectableFields, {});
    },
  },
});
